module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Mostly Somewhat Putative Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("All dates are BCE unless otherwise stated.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("1150")]), _vm._v(" Fall of Troy")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("753")]), _vm._v(" Romulus founds Rome")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("716")]), _vm._v(" Death of Romulus; accession of Numa Pompilius")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("673")]), _vm._v(" Death of Numa Pompilius; accession of Tullus Hostilius")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("642")]), _vm._v(" Death of Tullus Hostilius; accession of Ancus Marcius")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("617")]), _vm._v(" Death of Ancus Marcius; accession of Tarquinius Priscus")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("579")]), _vm._v(" Death of Tarquinius Priscus; accession of Servius Tullius")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("535")]), _vm._v(" Death of Servius Tullius; accession of Tarquin the Proud")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("509")]), _vm._v(" Tarquin the Proud is expelled from Rome; Brutus establishes the Republic")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("508")]), _vm._v(" Mucius Scaevola attempts to kill Lars Porsena, king of Clusium; Cloelia swims to safety")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("493")]), _vm._v(" Coriolanus defeats the Volscians")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("458")]), _vm._v(" Cincinnatus is appointed dictator")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("449")]), _vm._v(" Appius Claudius lusts after Verginia")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("396")]), _vm._v(" Veii is destroyed")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("394")]), _vm._v(" Camillus rejects an offer from the Falerian schoolteacher")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("387")]), _vm._v(" The Romans are defeated at the Battle of the Allia; the Gauls sack Rome")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("384")]), _vm._v(" Marcus Manlius is thrown from the Tarpeian Rock")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("340")]), _vm._v(" Decius Mus sacrifices himself to the spirits of the dead")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("321")]), _vm._v(" The Battle of the Caudine Forks")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("279")]), _vm._v(" Pyrrhus wins a pyrrhic victory")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("249")]), _vm._v(" Publius Claudius Pulcher fails to heed the warning from the sacred chickens and loses the Battle of Drepana")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("218")]), _vm._v(" Hannibal crosses the Alps")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("216")]), _vm._v(" Hannibal defeats the Romans at the Battle of Cannae")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("204")]), _vm._v(" The Great Mother arrives in Rome")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("202")]), _vm._v(" Hannibal is defeated at the Battle of Zama")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("172")]), _vm._v(" Antiochus IV Epiphanes is humiliated")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("146")]), _vm._v(" Carthage is destroyed")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("133")]), _vm._v(" Assassination of Tiberius Gracchus")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("121")]), _vm._v(" Assassination of Gaius Gracchus")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("107")]), _vm._v(" Marius reforms the Roman army")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("81")]), _vm._v(" Sulla becomes dictator")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("73–1")]), _vm._v(" Revolt of Spartacus")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("49")]), _vm._v(" Julius Caesar crosses the Rubicon")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("44")]), _vm._v(" Julius Caesar is assassinated")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("27")]), _vm._v(" Octavian becomes Augustus")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("CE 410")]), _vm._v(" Alaric the Goth sacks Rome")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1847efa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Chronology.vue
// module id = 72
// module chunks = 0